import { graphql } from "../gql";

export const getAgentsQueryDoc = graphql(`
  query getAgents($input: AgentsInput!) {
    agents(input: $input) {
      ...AgentFragment
    }
  }
`);
